import React from "react";
import PageWrapper from "../components/layout/PageWrapper";
import InvoiceSummary from "../components/invoiceSummary/invoiceSummary";

const InvoiceSummaryPage = () => {
  return (
    <PageWrapper>
      <InvoiceSummary />
    </PageWrapper>
  );
};

export default InvoiceSummaryPage;
